import "zone.js/plugins/zone-patch-rxjs";
import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { addIcons } from "ionicons";
import {
	add,
	bookmark,
	bookmarkOutline,
	checkmark,
	chevronBackOutline,
	chevronForwardOutline,
	close,
	closeCircle,
	cloudDownload,
	cloudOfflineOutline,
	copyOutline,
	create,
	createOutline,
	download,
	exit,
	filterOutline,
	flag,
	helpOutline,
	move,
	notifications,
	notificationsOff,
	pencilOutline,
	personRemove,
	pin,
	refreshOutline,
	remove,
	search,
	settings,
	settingsOutline,
	shareOutline,
	time,
	timer,
	trash,
	trashOutline
} from "ionicons/icons";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

import { defineCustomElements } from "@ionic/pwa-elements/loader";

// ─── Filtre de logs console ──────────────────────────────────────────────────
// Réduit le bruit : seuls les messages liés à l'OTA (préfixe [OTA]) sont conservés
// pour log / info / debug / warn. `console.error` reste toujours actif (on ne masque
// jamais les vraies erreurs). Posé avant le bootstrap pour s'appliquer au plus tôt.
(() => {
	const KEEP = "[OTA]";
	const c = console as unknown as Record<string, (...args: unknown[]) => void>;
	(["log", "info", "debug", "warn"] as const).forEach((method) => {
		const original = c[method].bind(console);
		c[method] = (...args: unknown[]): void => {
			if (args.some((a) => typeof a === "string" && a.includes(KEEP))) {
				original(...args);
			}
		};
	});
})();

/**
 * Register all Ionicons used across the app.
 * Required for standalone Ionic (no IonicModule).
 */
addIcons({
	add,
	bookmark,
	"bookmark-outline": bookmarkOutline,
	checkmark,
	"chevron-back-outline": chevronBackOutline,
	"chevron-forward-outline": chevronForwardOutline,
	close,
	"close-circle": closeCircle,
	"cloud-download": cloudDownload,
	"cloud-offline-outline": cloudOfflineOutline,
	"copy-outline": copyOutline,
	create,
	"create-outline": createOutline,
	download,
	exit,
	"filter-outline": filterOutline,
	flag,
	"help-outline": helpOutline,
	move,
	notifications,
	"notifications-off": notificationsOff,
	"pencil-outline": pencilOutline,
	"person-remove": personRemove,
	pin,
	"refresh-outline": refreshOutline,
	remove,
	search,
	settings,
	"settings-outline": settingsOutline,
	"share-outline": shareOutline,
	time,
	timer,
	trash,
	"trash-outline": trashOutline
});

if (environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error("**** Error bootstrap application: ", err));

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);
